<template>
  <v-table
    class="table-data"
    fixed-header>
    <thead>
      <tr>
        <th v-for="item in headers"
          :key="item" class="text-left">
          {{item}}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in extras"
        :key="item._id">
        <td>{{ item.name }}</td>
        <td>{{ formatTimestamp(item.updated_at) }}</td>
        <td>{{ formatMoney(item.price) }}</td>
        <td>{{ item.terminal.name }}</td>
        <td>
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"/>
            </template>
            <v-list>
              <v-list-item  title="Editar" link
              @click="editModal(item)"/>
              <v-list-item  title="Eliminar" link
              @click="openDialogDelete(item)"/>
            </v-list>
          </v-menu>
        </td>
      </tr>
    </tbody>
  </v-table>

  <add-edit-extras ref="addEditModal" @refreshList="refresh"/>

  <diaog-two-options
    ref="deleteDialog"
    @okBtn="deleteObj"
    title="Eliminar extra"
    txtBtn="Sí, Eliminar"
    :txtBold="objSelected?.name || ''"
    txtOne="¿Deseas eliminar "
    txtTwo="? No podrás deshacer la acción."/>

</template>

<script>
import AddEditExtras from '../forms/AddEditExtras.vue'
import DiaogTwoOptions from '../dialogs/DiaogTwoOptions.vue'
import extrasApi from '@/api/extrasApi'
import dateTransform from '@/utils/dateTransform'
import moneyTransform from '@/utils/moneyTransform'
export default {
  name: 'CommerciaVueExtrasTable',
  emits: ['refreshList'],
  components: {
    AddEditExtras,
    DiaogTwoOptions
  },
  props: {
    extras: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      objSelected: null,
      headers: ['Extra', 'Editado', 'Precio',
        'POS Asociado', 'Acciones']
    }
  },

  methods: {
    editModal (obj) {
      this.$refs.addEditModal.edit(obj)
    },
    openDialogDelete (obj) {
      this.objSelected = obj
      this.$refs.deleteDialog.open()
    },
    async deleteObj () {
      console.log(this.objSelected)
      if (await extrasApi.delete(this.objSelected)) {
        this.$emit('refreshList')
      } else {
        console.log('Cambio Fallido')
      }
    },
    refresh () { this.$emit('refreshList') },
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    },
    formatMoney (intValue) {
      return moneyTransform.intToMoney(intValue)
    }

  }
}
</script>
<style scoped>
  @import '@/assets/styles/tables.css';
</style>
